import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { AuthWrapper } from "@/components/layout"
import { Button } from "@/components/ui/button"

/**
 * WelcomeScreen - Pixel-perfect implementation matching image copy 8.png
 *
 * Design specs:
 * - WHITE HEADER BAR at top (60px height, 100% width, border-bottom)
 * - Background: #F8F5F2 with scattered decorative diamonds
 * - Decorative elements: rotated squares (45deg), sizes 8-12px, varied colors
 * - Centered white card (620px max-width for wider look)
 * - "RITUALITY" in header: Medium weight (500), 24px, letter-spacing: 0.05em
 */
export function WelcomeScreen() {
  const { t } = useTranslation("onboarding")
  const navigate = useNavigate()

  return (
    <div className="relative h-[calc(100vh-120px)] flex items-center justify-center ">
      {/* Main Content - Centered White Card */}
      <AuthWrapper maxWidth="640px">
        <div className="md:w-[584px] w-full pt-5 pb-6.75">
          {/* Brand Name in Card */}
          <div className="text-center mb-3.75">
            <h2 className="text-[24px] leading-normal font-medium font-monteserat text-primary">
              Welcome
            </h2>
          </div>

          {/* Subtitle */}
          <p className="text-center leading-relaxed mb-7.5 text-primary text-[14px] max-w-[345px] mx-auto">
            {t("welcome.subtitle")}
          </p>

          {/* Start Exploring Button */}
          <div className="flex justify-center">
            <Button
              variant="primary"
              onClick={() => navigate("/")}
              className="w-[220px] h-12.5 font-medium rounded-full uppercase"
            >
              {t("welcome.getStarted")}
            </Button>
          </div>
        </div>
      </AuthWrapper>
    </div>
  )
}
